const embedElement = 'root';

const testPandaPayPublicKey = 'pk_test_99wLIEGW-t4LifFKEKUeqQ';
const productionPandaPayPublicKey = 'pk_live_AQsY1s0Pz4t4FL-cZYuU7Q';

const testGoogleAnalytics = 'UA-67279182-3';
const testEventsGoogleAnalytics = 'UA-67279182-12';
const productionGoogleAnalytics = 'UA-67279182-4';
const productionEventsGoogleAnalytics = 'UA-67279182-13';

const configLocal = {
    EMBED_ELEMENT: embedElement,
    API_BASE_URL: 'https://qa-api.actionbutton.co/api/',
    CDN_URL: 'https://qa-api.actionbutton.co/api/logos/get/',
    SCRIPT_URL: 'https://localhost:3000/',
    PANDA_PAY_PUBLIC_KEY: testPandaPayPublicKey,
    GOOGLE_ANALYTICS_USER_ID: testGoogleAnalytics,
    GOOGLE_ANALYTICS_EVENTS_USER_ID: testEventsGoogleAnalytics,
    SENTRY_ENV: 'localhost'
};

const configQa = {
    EMBED_ELEMENT: embedElement,
    API_BASE_URL: 'https://qa-api.actionbutton.co/api/',
    CDN_URL: 'https://qa-api.actionbutton.co/api/logos/get/',
    SCRIPT_URL: 'https://s3.amazonaws.com/embed.actionbutton.co/qa/widget/',
    PANDA_PAY_PUBLIC_KEY: testPandaPayPublicKey,
    GOOGLE_ANALYTICS_USER_ID: testGoogleAnalytics,
    GOOGLE_ANALYTICS_EVENTS_USER_ID: testEventsGoogleAnalytics,
    SENTRY_ENV: 'https://qa-api.actionbutton.co/api/'
};

const configStage = {
    EMBED_ELEMENT: embedElement,
    API_BASE_URL: 'https://stage-api.actionbutton.co/api/',
    CDN_URL: 'https://stage-api.actionbutton.co/api/logos/get/',
    SCRIPT_URL: 'https://s3.amazonaws.com/embed.actionbutton.co/stage/widget/',
    PANDA_PAY_PUBLIC_KEY: testPandaPayPublicKey,
    GOOGLE_ANALYTICS_USER_ID: testGoogleAnalytics,
    GOOGLE_ANALYTICS_EVENTS_USER_ID: testEventsGoogleAnalytics,
    SENTRY_ENV: 'https://stage-api.actionbutton.co/api/'
};

const configProduction = {
    EMBED_ELEMENT: embedElement,
    API_BASE_URL: 'https://api.actionbutton.co/api/',
    CDN_URL: 'https://static.actionbutton.co/',
    SCRIPT_URL: 'https://embed.actionbutton.co/widget/',
    PANDA_PAY_PUBLIC_KEY: productionPandaPayPublicKey,
    GOOGLE_ANALYTICS_USER_ID: productionGoogleAnalytics,
    GOOGLE_ANALYTICS_EVENTS_USER_ID: productionEventsGoogleAnalytics,
    SENTRY_ENV: 'https://api.actionbutton.co/api/'
};

const getConfig = () => {
    switch (process.env.REACT_APP_ENV || process.env.REACT_STATIC_ENV) {
        case 'node':
            return configLocal;
        case 'local':
            return configLocal;
        case 'qa':
            return configQa;
        case 'stage':
            return configStage;
        case 'production':
            return configProduction;
        default:
            throw new Error('Environment not valid!');
    }
};

const config = getConfig();

export default config;



// WEBPACK FOOTER //
// ./src/config.js